export { default } from './InputQuantity';
